import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import employerReducer from "./employer";
import userReducer from "./user";


// Creating Store
const store = configureStore(
    {
        reducer: {
            user: userReducer,
            employer: employerReducer,
            auth: authReducer
        }
    }
)

export default store